import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

export default function Visa() {
  return (
    <>
      <PageHero
        eyebrow="Participant info"
        title="Visa"
        intro="Check whether your nationality requires a Schengen visa and follow the official application procedure."
      />

      <main className="info-page py-5">
        <Container>
          <Row className="justify-content-center mt-5">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className='h1'>Schengen visa and invitation letter</h2>
                <p>
                  Participants who require a visa to enter Slovenia should first <span class="text-marker">check whether their nationality requires a Schengen visa</span>, complete their conference registration, and then contact the relevant Slovenian embassy or consulate to submit their application.
                </p>
                <p>
                  Standard Schengen documents may be requested, including passport, photo, travel plan, accommodation, insurance and financial proof. Requirements vary by country, so applicants should follow the instructions of the diplomatic mission handling their case.
                </p>
                <p>
                  To obtain the official Slovenian Letter of Invitation / Guarantee, participants must complete the required form and contact the organizers at <a href="mailto:info@eac2027.si">info@eac2027.si</a> so we can provide the signed document.
                </p>
              </section>
            </Col>
          </Row>
        </Container>
      </main>

    </>
  );
}
